// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';
import { LMFormatUtilService } from '../services/utils';
import { LMModel } from '../components/form/model';

@Pipe({
  name: 'formatLabelRule',
  standalone: false
})
export class LMFormatLabelPipe implements PipeTransform {
  constructor(private lmFormatUtilService: LMFormatUtilService) {
  }

  transform(value, layoutField: LMFormLayoutField, messageRule: LMMessageRule | string, data: LMModel | LMDataView, specFields?: LMSpecFields): string {
    return  messageRule && !layoutField.labelSuppressed ? this.lmFormatUtilService.formatMessageRule(messageRule, data, specFields) : '';
  }
}
